var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DashboardSales", {
        attrs: { outStandingSales: _vm.outStandingSales }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "my-4": "" } },
        [
          _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
            _c(
              "table",
              { staticClass: "text-xs-center", attrs: { width: "100%" } },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Order Code")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Customer Name")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Sales Contact")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Remailning Balance")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Collected")])
                  ])
                ]),
                _vm._v(" "),
                _vm.orders.length
                  ? _c(
                      "tbody",
                      _vm._l(_vm.orders, function(order, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(order.orderCode))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(order.customerID.firstName) +
                                " " +
                                _vm._s(order.customerID.lastName)
                            )
                          ]),
                          _vm._v(" "),
                          order.updatedBy
                            ? _c("td", [
                                _vm._v(
                                  _vm._s(order.updatedBy.firstName) +
                                    " " +
                                    _vm._s(order.updatedBy.lastName)
                                )
                              ])
                            : order.createdBy
                            ? _c("td", [
                                _vm._v(
                                  _vm._s(order.createdBy.firstName) +
                                    " " +
                                    _vm._s(order.createdBy.lastName)
                                )
                              ])
                            : _c("td", [_vm._v("Online")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("$" + _vm._s(_vm.getRemainingBalance(order)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mark-as-collected",
                                  attrs: { color: "grey", dark: "", large: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.markAsCollected(order)
                                    }
                                  }
                                },
                                [_vm._v("Mark as collected")]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  : _c("tbody", [
                      _c("tr", [
                        _c("td", { attrs: { colspan: "5" } }, [
                          _vm._v("No Records found")
                        ])
                      ])
                    ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4060df97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4060df97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDashboard.vue
// module id = null
// module chunks = 